import InfoCardFooter from './info-card-footer';

export default InfoCardFooter;